import React, { Component } from 'react';
import '../custom.css';
import { Helmet } from 'react-helmet';

export class Agb extends Component {
  static displayName = Agb.name;

  render() {
    return (
      <div className="agb-page">
        <Helmet>
          <title>Allgemeine Geschäftsbedingungen - ho.li design</title>
          <meta name="description" content="Allgemeine Geschäftsbedingungen von ho.li design" />
          <meta name="keywords" content="AGB, ho.li design, rechtliche Hinweise" />
          <meta name="language" content="de" />
          <link rel="canonical" href="https://holidesign.de/agb" />
        </Helmet>
        <h1 style={{ marginBottom: '40px' }}>Allgemeine Geschäftsbedingungen</h1>
        <ol style={{ marginBottom: '40px' }}>
          <li>Geltungsbereich</li>
          <li>Vertragspartner</li>
          <li>Vertragsschluss</li>
          <li>Widerrufsrecht</li>
          <li>Preise und Versandkosten</li>
          <li>Lieferung</li>
          <li>Zahlung</li>
          <li>Eigentumsvorbehalt</li>
          <li>Sachmängelgewährleistung</li>
          <li>Streitbeilegung</li>
        </ol>
        <p><strong>Allgemeine Geschäftsbedingungen</strong></p>
        <ol className="bold-list" style={{ marginBottom: '60px' }}> 
          <li className="bold-list-item">
            <strong>Geltungsbereich</strong>
            <br />
            Für alle Bestellungen über unseren Online-Shop und alle Lieferungen von ho.li design GmbH an Verbraucher gelten diese Allgemeinen Geschäftsbedingungen (AGB). Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu einem Zwecke abschließt, der überwiegend weder ihrer gewerblichen noch ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden kann.
          </li>
          <li className="bold-list-item">
            <strong>Vertragspartner</strong>
            <br />
            Der Kaufvertrag kommt zustande mit <br />
            ho.li design GmbH <br />
            Inhaber: Laura Albert, Andreas Albert <br />
            Otto-Rienecker-Str. 24 <br />
            97789 Oberleichtersbach <br />
            Handelsregister: Schweinfurt, HRB 9454.
          </li>
          <li className="bold-list-item">
            <strong>Vertragsschluss</strong>
            <br />
            <ol>
              <li>Die Darstellung der Produkte im Online-Shop stellt kein rechtlich bindendes Angebot, sondern nur eine Aufforderung zur Bestellung dar.</li>
              <li>Durch Anklicken des Buttons [Kaufen/kostenpflichtig bestellen] geben Sie eine verbindliche Bestellung der auf der Bestellseite aufgelisteten Waren ab. Ihr Kaufvertrag kommt zustande, wenn wir Ihre Bestellung durch eine Auftragsbestätigung per E-Mail unmittelbar nach dem Erhalt Ihrer Bestellung annehmen.</li>
            </ol>
          </li>
          <li className="bold-list-item">
            <strong>Widerrufsrecht</strong>
            <br />
            <ol>
              <li>Wenn Sie Verbraucher sind (also eine natürliche Person, die die Bestellung zu einem Zweck abgibt, der weder Ihrer gewerblichen oder selbständigen beruflichen Tätigkeit zugerechnet werden kann), steht Ihnen nach Maßgabe der gesetzlichen Bestimmungen ein Widerrufsrecht zu.</li>
              <li>Wenn Sie als Verbraucher von Ihrem Widerrufsrecht Gebrauch machen, beträgt die Rückgabefrist 30 Tage ab dem Tag, an dem Sie die Waren erhalten haben. Nach dem Widerruf sind die Waren unverzüglich an uns zurückzusenden. Die Rücksendekosten übernimmt ho.li design GmbH.</li>
              <li>Im Übrigen gelten für das Widerrufsrecht die Regelungen, die im Einzelnen wiedergegeben sind in der folgenden <br />
              <br />
              <strong>Widerrufsbelehrung</strong><br />
              <br />
              <strong>Widerrufsrecht</strong><br />
              <br />
              Sie haben das Recht, binnen 30 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.<br />
              <br />
              Die Widerrufsfrist beträgt 30 Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.<br />
              <br />
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns [ho.li design GmbH, Otto-Rienecker-Str. 24, 97789 Oberleichtersbach, info@holidesign.de] mittels einer eindeutigen Erklärung (zB ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Machen Sie von dieser Möglichkeit Gebrauch, so werden wir Ihnen unverzüglich (zB per E-Mail) eine Bestätigung über den Eingang eines solchen Widerrufs übermitteln.<br />
              <br />
              Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.<br />
              <br />
              <strong>Folgen des Widerrufs</strong><br />
              <br />
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet. Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.<br />
              <br />
              Sie haben die Waren unverzüglich nach dem Widerruf an uns zurückzusenden oder zu übergeben. Die Rücksendung muss unmittelbar erfolgen; eine zusätzliche Frist beginnt nicht erneut.<br />
              <br />
              Die unmittelbaren Kosten der Rücksendung der Waren trägt ho.li design GmbH.<br />
              <br />
              Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.<br />
              <br />
              <strong>- Ende der Widerrufsbelehrung –</strong><br />
              <br />
              </li>
              <li>Über das Muster-Widerrufsformular informiert ho.li design nach der gesetzlichen Regelung wie folgt:<br />
              <br />
              <strong>Muster-Widerrufsformular</strong><br />
              <br />
              (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)<br />
              <br />
              - An ho.li design GmbH, Otto-Rienecker-Str. 24, 97789 Oberleichtersbach, info@holidesign.de:<br />
              –Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)<br />
              –Bestellt am (*)/erhalten am (*)<br />
              –Name des/der Verbraucher(s)<br />
              –Anschrift des/der Verbraucher(s)<br />
              –Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)<br />
              –Datum __________<br />
              (*) Unzutreffendes streichen<br />
              <br />
              </li>
            </ol>
          </li>
          <li className="bold-list-item">
            <strong>Preise und Versandkosten</strong>
            <br />
            <ol>
              <li>Die auf den Produktseiten genannten Preise enthalten die gesetzliche Mehrwertsteuer und sonstige Preisbestandteile.</li>
              <li>Die Versandkosten werden Ihnen auf den Produktseiten, im Warenkorbsystem und auf der Bestellseite nochmals deutlich mitgeteilt.</li>
            </ol>
          </li>
          <li className="bold-list-item">
            <strong>Lieferung</strong>
            <br />
            <ol>
              <li>Die Lieferung erfolgt nur innerhalb Deutschlands.</li>
              <li>Die Lieferzeit beträgt in der Regel 2-3 Werktage. Auf eventuell abweichende Lieferzeiten weisen wir auf der jeweiligen Produktseite hin.</li>
            </ol>
          </li>
          <li className="bold-list-item">
            <strong>Zahlung</strong>
            <br />
            <p>Die Zahlung erfolgt per Kreditkarte.</p>
          </li>
          <li className="bold-list-item">
            <strong>Eigentumsvorbehalt</strong>
            <br />
            <p>Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.</p>
          </li>
          <li className="bold-list-item">
            <strong>Sachmängelgewährleistung</strong>
            <br />
            <p>ho.li design GmbH haftet für Sachmängel nach den hierfür geltenden gesetzlichen Vorschriften, insbesondere §§ 434 ff Bürgerliches Gesetzbuch.</p>
          </li>
          <li className="bold-list-item">
            <strong>Streitbeilegung</strong>
            <br />
            <p>Die EU-Kommission hat eine Internetplattform zur Online-Beilegung von Streitigkeiten geschaffen. Die Plattform dient als Anlaufstelle zur außergerichtlichen Beilegung von Streitigkeiten betreffend vertragliche Verpflichtungen, die aus Online-Kaufverträgen erwachsen. Nähere Informationen sind unter dem folgenden Link verfügbar: <a href="http://ec.europa.eu/consumers/odr" rel="noreferrer" target="_blank">http://ec.europa.eu/consumers/odr</a>. Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir weder bereit noch verpflichtet.</p>
          </li>
        </ol>
      </div>
    );
  }
}
